<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title text-uppercase">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body position-relative">
            <CContainer fluid>
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
            </CContainer>
            <CContainer fluid>
                <div
                    @mouseover="upCounts = true"
                    @mouseleave="upCounts = false"
                >
                    <CRow class="mt-5">
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Deliverers") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.deliverers.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.deliverers.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.deliverers.percentage"
                                color="info"
                                size="xs"
                            />
                        </CCol>
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Openers") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.openers.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.openers.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.openers.percentage"
                                color="primary"
                                size="xs"
                            />
                        </CCol>
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Clickers") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.clickers.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.clickers.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.clickers.percentage"
                                color="success"
                                size="xs"
                            />
                        </CCol>
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Deferreds") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.deferreds.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.deferreds.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.deferreds.percentage"
                                color="danger"
                                size="xs"
                            />
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Invalid emails") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.invalidEmail.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.invalidEmail.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.invalidEmail.percentage"
                                color="secondary"
                                size="xs"
                            />
                        </CCol>
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Soft Bounces") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.softBounces.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.softBounces.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.softBounces.percentage"
                                color="secondary"
                                size="xs"
                            />
                        </CCol>
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Hard Bounces") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.hardBounces.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.hardBounces.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.hardBounces.percentage"
                                color="secondary"
                                size="xs"
                            />
                        </CCol>
                        <CCol md="3">
                            <div
                                class="d-flex justify-content-between progressBar"
                            >
                                <p class="mb-1">
                                    {{ $t("Blockeds") }}
                                </p>
                                <p class="mb-1" v-show="upCounts">
                                    <strong>{{
                                        progressBar.blocked.number
                                    }}</strong>
                                </p>
                                <p class="mb-1" v-show="!upCounts">
                                    <strong
                                        >{{
                                            progressBar.blocked.percentage
                                        }}%</strong
                                    >
                                </p>
                            </div>
                            <CProgress
                                :value="progressBar.blocked.percentage"
                                color="secondary"
                                size="xs"
                            />
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5">
                    <CCol md="12">
                        <CCard class="position-relative shadow">
                            <CCardBody>
                                <CChartLine
                                    style="height: 350px"
                                    :datasets="charts.byDate.datasets"
                                    :labels="charts.byDate.labels"
                                    :options="charts.byDate.options"
                                />
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol md="12">
                        <CCard class="position-relative shadow">
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.logs.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.logs.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.logs.columnFilterValue
                                    "
                                    :sorterValue.sync="tables.logs.sorterValue"
                                    @update:column-filter-value="updateLogs()"
                                    @update:sorter-value="updateLogs()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.logs"
                                >
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter class="text-center">
                                <a
                                    class="aLink"
                                    @click="
                                        $router.push({
                                            name: 'logs',
                                        })
                                    "
                                >
                                    {{ $t("See more records") }}
                                </a>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

import FilterDate from "~/components/FilterDate";
import { CChartLine } from "@coreui/vue-chartjs";
import { mapGetters } from "vuex";
import LogsTable from "./config/tables/LogsTable";
import { QueryBuilder } from "~/utils/queryBuilder.js";

export default {
    name: "StatisticsCRM",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        CChartLine,
    },
    data() {
        return {
            upCounts: false,
            progressBar: {
                deliverers: {
                    number: 0,
                    percentage: 0,
                },
                openers: {
                    number: 0,
                    percentage: 0,
                },
                clickers: {
                    number: 0,
                    percentage: 0,
                },
                deferreds: {
                    number: 0,
                    percentage: 0,
                },
                invalidEmail: {
                    number: 0,
                    percentage: 0,
                },
                softBounces: {
                    number: 0,
                    percentage: 0,
                },
                hardBounces: {
                    number: 0,
                    percentage: 0,
                },
                blocked: {
                    number: 0,
                    percentage: 0,
                },
            },
            charts: {
                byDate: {
                    datasets: [],
                    labels: [],
                    loading: true,
                    options: {
                        tooltips: {
                            titleMarginBottom: 10,
                            titleFontColor: "#6e707e",
                            titleFontSize: 14,
                            backgroundColor: "rgb(255,255,255)",
                            bodyFontColor: "#858796",
                            borderColor: "#dddfeb",
                            borderWidth: 1,
                            xPadding: 15,
                            yPadding: 15,
                            displayColors: false,
                            caretPadding: 10,
                        },
                        maintainAspectRatio: false,
                        layout: {
                            padding: {
                                left: 10,
                                right: 25,
                                top: 25,
                                bottom: 0,
                            },
                        },
                        scales: {
                            xAxes: [
                                {
                                    time: {
                                        unit: "month",
                                    },
                                    gridLines: {
                                        color: "rgb(234, 236, 244)",
                                        zeroLineColor: "rgb(234, 236, 244)",
                                        drawBorder: false,
                                        borderDash: [2],
                                        zeroLineBorderDash: [2],
                                    },
                                    ticks: {
                                        min: 0,
                                        maxTicksLimit: 15,
                                        padding: 10,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        min: 0,
                                        maxTicksLimit: 15,
                                        padding: 10,
                                    },
                                    gridLines: {
                                        color: "rgb(234, 236, 244)",
                                        zeroLineColor: "rgb(234, 236, 244)",
                                        drawBorder: false,
                                        borderDash: [2],
                                        zeroLineBorderDash: [2],
                                    },
                                },
                            ],
                        },
                    },
                },
            },
            tables: {
                logs: LogsTable,
            },
        };
    },
    computed: {
        ...mapGetters({
            default_colors: "global/default_colors",
            from: "filter/from",
            to: "filter/to",
        }),
    },
    methods: {
        async updateData() {
            this.updatePageLoading(true);
            let statistics = await this.fetcher({
                baseURL: process.env.VUE_APP_API_SASS,
                url: "/brevo/getstadistics",
                query: {
                    from: this.from,
                    to: this.to,
                },
            });
            if (statistics?.totals) {
                await this.updateTotals(statistics.totals);
            }
            if (statistics?.byDate) {
                await this.updateChart(statistics.byDate);
            }

            await this.updateLogs();

            this.updatePageLoading(false);
        },
        async updateChart(byDate) {
            this.charts.byDate.labels = byDate.map((item) => item.date);
            this.charts.byDate.datasets = [
                {
                    data: byDate.map((item) => item.delivered),
                    backgroundColor: "transparent",
                    borderColor: "#17a2b8",
                    label: "Delivered",
                },
                {
                    data: byDate.map((item) => item.opened),
                    backgroundColor: "transparent",
                    borderColor: "#007bff",
                    label: "Opened",
                },
                {
                    data: byDate.map((item) => item.clicked),
                    backgroundColor: "transparent",
                    borderColor: "#28a745",
                    label: "Clicked",
                },
                {
                    data: byDate.map((item) => item.deferred),
                    backgroundColor: "transparent",
                    borderColor: "#dc3545",
                    label: "Deferred",
                },
            ];
        },
        async updateTotals(totals) {
            this.progressBar.deliverers.number = totals.nDelivered;
            this.progressBar.deferreds.number = totals.nDeferred;

            let divider = Number(totals.nDelivered) + Number(totals.nDeferred);
            if (divider > 0) {
                this.progressBar.deliverers.percentage = Math.round(
                    (Number(totals.nDelivered) / divider) * 100
                );
                this.progressBar.deferreds.percentage = Math.round(
                    (Number(totals.nDeferred) / divider) * 100
                );
            } else {
                this.progressBar.deliverers.percentage = 0;
                this.progressBar.deferreds.percentage = 0;
            }

            this.progressBar.openers.number = totals.nOpened;
            if (Number(totals.nDelivered) > 0) {
                this.progressBar.openers.percentage = Math.round(
                    (Number(totals.nOpened) / Number(totals.nDelivered)) * 100
                );
            } else {
                this.progressBar.openers.percentage = 0;
            }

            this.progressBar.clickers.number = totals.nClicked;
            if (Number(totals.nOpened) > 0) {
                this.progressBar.clickers.percentage = Math.round(
                    (Number(totals.nClicked) / Number(totals.nOpened)) * 100
                );
            } else {
                this.progressBar.clickers.percentage = 0;
            }

            this.progressBar.invalidEmail.number = totals.nInvalidEmail;
            this.progressBar.softBounces.number = totals.nSoftBounces;
            this.progressBar.hardBounces.number = totals.nHardBounces;
            this.progressBar.blocked.number = totals.nBlocked;

            if (Number(totals.nDeferred) > 0) {
                this.progressBar.invalidEmail.percentage = Math.round(
                    (Number(totals.nInvalidEmail) / Number(totals.nDeferred)) *
                        100
                );
                this.progressBar.softBounces.percentage = Math.round(
                    (Number(totals.nSoftBounces) / Number(totals.nDeferred)) *
                        100
                );
                this.progressBar.hardBounces.percentage = Math.round(
                    (Number(totals.nHardBounces) / Number(totals.nDeferred)) *
                        100
                );
                this.progressBar.blocked.percentage = Math.round(
                    (Number(totals.nBlocked) / Number(totals.nDeferred)) * 100
                );
            } else {
                this.progressBar.invalidEmail.percentage = 0;
                this.progressBar.softBounces.percentage = 0;
                this.progressBar.hardBounces.percentage = 0;
                this.progressBar.blocked.percentage = 0;
            }
        },
        adapterFiltersToUseDate(query) {
            query = new QueryBuilder(query);
            query.createdAtToDate();
            return query.getQuery();
        },
        async updateLogs() {
            await this.updateTable({
                tableName: "logs",
                baseURL: process.env.VUE_APP_API_SASS,
                url: "/brevo/gethistorylogs",
                adapterFilters: this.adapterFiltersToUseDate,
            });
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style>
.aLink {
    cursor: pointer;
    font-size: 0.875rem;
}
.progressBar p {
    font-size: 0.875rem;
}
</style>
